import React from "react";
import styles from "./FilterBar.scss";
import FilterHeader from "./FilterHeader/FilterHeader";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
    onClear?: () => void;
}

const FilterBar: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.filterBar}>
        <FilterHeader onClear={props.onClear} />
        {props.children}
    </div>
);

export default FilterBar;


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterBar.tsx